export const baseUrl = "https://api.cryptograd.ai/v1";
export const baseUrlv2 = 'https://api.cryptograd.ai/v2';
export const domain = "dev-k7lpg62sfkr2ag2d.us.auth0.com";
export const clientId = "95NG91ULruTSICYFWZZnd0zRAvzgALiX";
export const audience = "audience";
